import React from 'react';
import { Typography, Paper } from '@mui/material';
import useThemeStyles from '../../../../../../../hooks/useThemeStyles';

const EmptyState = () => {
  const { colors, components, isDark } = useThemeStyles();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        backgroundColor: isDark ? '#1e293b' : colors.paper.background,
        backgroundImage: isDark ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : 'none',
        border: components.card.border,
        borderRadius: 2,
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: colors.text.secondary,
          mb: 1,
        }}
      >
        No chapters yet
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: colors.text.secondary,
        }}
      >
        Add your first chapter to get started with your manuscript.
      </Typography>
    </Paper>
  );
};

EmptyState.propTypes = {};

export default EmptyState;
